import styled from 'styled-components';
import {V6} from '../../theme';
import {Badge} from './Badge';

export const SaleBadge = styled(Badge)`
  color: ${V6.badges.colors.sale};
  background-color: ${V6.badges.backgroundColors.sale};
`;
